import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { PaymentCardModel } from "@/features/paymentCards/models/PaymentCardModel";

export const usePaymentCardDelete = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, string> = paymentCardId => {
		return http({
			method: "DELETE",
			url: `/payment-card/${paymentCardId}`
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, paymentCardId) => {
			queryClient.setQueryData(["paymentCards"], (oldData: PaymentCardModel[] | undefined) => {
				if (!oldData) {
					return [];
				}
				return oldData.filter(x => x.paymentCardId !== paymentCardId);
			});
		}
	});
};
